module.exports = __webpack_public_path__ + "static/media/isb.bb8b3379.png";